"use client";
import { OverlayViewF, OverlayView } from "@react-google-maps/api";

const CarIcon = ({ rotation, img, dispatch }) => (
  <img
    src={
      img ||
      "https://zervx.sgp1.digitaloceanspaces.com/zervx-storage/categorymapimage.[0].suvvehiclecategorylp0rv3d4.jpg"
    }
    alt="vehicleCategoryMapImage"
    style={{
      width: img ? 35 : 18,
      height: img ? 35 : 26,
      transform: `rotate(${rotation}deg)`,
      transition: "transform 0.5s ease-in-out",
    }}
  />
);

function DriverMarkers({
  driver,
  image,
  dispatch,
  clickReq,
  onClicked,
  bg,
  selected,
}) {
  return (
    <>
      <OverlayViewF
        position={{ lat: driver.lat, lng: driver.lng }}
        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
      >
        <div
          style={{
            position: "absolute",
            transform: "translate(-50%, -50%)",
            background: bg,
          }}
          onClick={() => clickReq && onClicked()}
          className={`  rounded-full `}
        >
          <CarIcon
            dispatch={dispatch}
            rotation={driver?.currentBearing}
            img={image}
          />
          {selected && (
            <div
              className={`absolute rounded-full top-0 animate-ping border-2  h-[35px] w-[35px] font-bold`}
              style={{ borderColor: bg }}
            ></div>
          )}
        </div>
      </OverlayViewF>
    </>
  );
}

export default DriverMarkers;
